import { render, staticRenderFns } from "./menu_management.vue?vue&type=template&id=dbaa3608&scoped=true"
import script from "./menu_management.vue?vue&type=script&lang=js"
export * from "./menu_management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaa3608",
  null
  
)

export default component.exports